module.exports = __webpack_public_path__ + "static/media/rw.6a1f1102.svg";